import { Component, Input } from '@angular/core';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { faHubspot } from '@fortawesome/free-brands-svg-icons';
import { MeetingSchedulingData } from '../../../../shared/models/meetings.model';

@Component({
  selector: 'app-meetings-profile',
  templateUrl: './meetings-profile.component.html',
  styleUrl: './meetings-profile.component.scss',
  standalone: false
})
export class MeetingsProfileComponent {
  @Input() schedulingData!: MeetingSchedulingData;

  public icons = {
    arrowLeft: faArrowLeft,
    hubspot: faHubspot,
  };
}
